/**
 * Хто з вкладок тримає сховище.
 *
 * SQLite у вебі лежить в OPFS, а `opfs-sahpool` захоплює свої файли
 * **ексклюзивно**: друга вкладка того самого сайту сховища не піднімає
 * взагалі. Досі це виглядало як «Сховище не відкрилося. Записи зараз
 * нікуди зберігати» — тобто як втрата даних, хоч архів цілий і просто
 * зайнятий сусідньою вкладкою.
 *
 * Правило: **забирає остання відкрита.** Саме цього людина й чекає,
 * відкриваючи нову вкладку; а та, що лишилася позаду, найчастіше просто
 * забута. Попередня паркується й показує кнопку повернути собі.
 *
 * Ping-pong неможливий за формою: вкладка, у якої забрали, **не**
 * перезабирає сама — лише за прямою дією людини.
 */
const CHANNEL = "beresta.storage";

/** Хто саме говорить: без цього вкладка почула б власне оголошення. */
const me = crypto.randomUUID();

interface Claim {
  readonly kind: "claim";
  readonly from: string;
}

let channel: BroadcastChannel | null = null;

function open(): BroadcastChannel | null {
  if (channel) return channel;
  // Приватні вікна й старі рушії можуть його не мати. Тоді лишається
  // поведінка, яка була досі: перша вкладка працює, друга просить закрити.
  if (typeof BroadcastChannel === "undefined") return null;
  channel ??= new BroadcastChannel(CHANNEL);
  return channel;
}

/**
 * Слухати чужі заявки. Викликається один раз на вкладку; `onLose`
 * зобовʼязаний **звільнити** сховище, а не просто перемалювати екран.
 */
export function watchClaims(onLose: () => void): void {
  const bus = open();
  if (!bus) return;
  bus.addEventListener("message", (event: MessageEvent<Claim>) => {
    if (event.data?.kind === "claim" && event.data.from !== me) onLose();
  });
}

/** Оголосити, що сховище тепер наше. Інші вкладки відпустять його самі. */
export function claimStorage(): void {
  open()?.postMessage({ kind: "claim", from: me } satisfies Claim);
}
